module.exports = __webpack_public_path__ + "423b6c68f0945f0999440c483afb7036.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/logo_dgc.jpg
// module id = 246
// module chunks = 0